function field(label, name) {
  const token = name
    .split(',')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');

  return { label, name, variable: `{${token}}` };
}

export const OS_DEAL_FIELDS = [
  field('Produto', 'product,name'),
  field('Complemento do Produto', 'product,complement'),
  field('Produto - Complemento', 'productWithComplement'),
  field('Detalhamento Técnico', 'productDescription'),
  field('Estágio', 'stage,id'),
  field('Data', 'startDate'),
  field('Horário Início', 'startHour'),
  field('Recurso', 'resource'),
  field('Instrutor', 'mainInstructor'),
  field('Instrutor Auxiliar', 'assistantInstructor'),
  field('Valor Instrutor', 'instructorValue'),
  field('Valor Instrutor Auxiliar', 'assistantInstructorValue'),
  field('Treinamentos', 'group,id'),
  field('Nome do Negócio na cotação', 'quoteTitle'),
  field('Transporte Oficial', 'trainingTransportation'),
  field('Responsável pelo Negócio', 'quoteResponsible'),
  field('Valor da Oportunidade', 'dealOportunity'),
  field('Número Negócio', 'dealId'),
  field('Nome do Negócio', 'dealTitle'),
  field('Cliente', 'dealClient'),
  field('Nome Fantasia', 'dealClientCommercialName'),
  field('Empresa Contratada', 'dealContractedCompany'),
  field('Endereço do CT para Treinamento', 'dealTrainingCenterAddress'),
  field('Condição de Pagamento', 'dealPaymentCondition'),
  field('Forma de Pagamento', 'dealPaymentForm'),
  field('Ordem de Compra Obrigatória', 'obrigatoryBuyOrder'),
  field('Data Limite para Faturamento Oficial', 'dealEndDateInvoice'),
  field('Retenção Tributária', 'dealTributaryRetention'),
  field('Cliente Prioritário', 'dealPrioritaryClient'),
  field('Observação Específica', 'dealClientObservation'),
  field('Necessidade do Cliente', 'dealClientNeed'),
  field('Pós venda', 'dealPostSale'),
  field('Datas de Treinamento Oficial', 'dealOfficialTrainingDates'),
  field('Indústria', 'dealIndustry'),
  field('Tipo de negócio', 'dealType'),
  field('Forma de Pagamento Negociada', 'dealPaymentFormNegotiated'),
  field('Condição de Pagamento Negociada', 'dealPaymentConditionNegotiated'),
  field('Emissão Nota Fiscal Oficial', 'officialInvoiceIssue'),
  field('Quantidade de Turmas', 'qtyClass'),
  field('Alunos por Turma', 'qtyStudentsPerClass'),
  field('Alunos Treinados', 'qtyStudentsTrained'),
  field('Alunos Transportados', 'qtyStudentsTransported'),
  field('Centro de Treinamento', 'trainingCenter'),
  field('Data do Agendamento', 'dateScheduling'),
  field('Lista de Presença Inicial', 'initialAttendanceDocList'),
  field('Lista de Presença Final', 'finalAttendanceDocList'),
  field('Formulário do Instrutor', 'instructorForm'),
  field('Pedido de Compra', 'downloadDealBuyOrder'),
  field('Pedido de Compra Oficial 2', 'downloadDealBuyOrderOfficial2'),
  field('Anexos Extras', 'downloadDealExtraAttachments'),
  field('Termo de Aceite', 'downloadAcceptTerm1'),
  field('Termo de Aceite Assinado', 'downloadAcceptTerm2'),
  field('Data de Recebimento do Termo Assinado', 'dateUploadAcceptTerm2'),
  field('Documentação Enviada', 'hasDocumentation'),
  field('Aceita Encaixe', 'acceptSharedTraining'),
  field('Lista de Presença Verificada', 'attendanceListChecked'),
  field('Produtos do Negócio', 'quoteProducts'),
  field('Observação Negócio', 'dealNotes'),
  field('Observação Comercial', 'commercialNotes'),
  field('Observação Logística', 'logisticsNotes'),
  field('Observação Financeiro', 'financeNotes'),
  field('Observação CT', 'ctNotes'),
  field('Observação Instrutor', 'instructorNotes'),
  field('Quando Avançado 24 horas Hibrido (Endereço Teoria)', 'advance24h'),
  field('Endereço de Parada Transporte', 'transportStopAddress'),
  field('Ponto de Referência', 'referencePoint'),
  field('Nome Responsável', 'responsiblePersonNameLogistic'),
  field('Telefone Responsável', 'responsiblePersonPhoneLogistic'),
  field('E-mail Responsável', 'responsiblePersonEmailLogistic'),
  field('Localização', 'mapLocation'),
  field('CEP', 'postalCodeLogistic'),
  field('Rua', 'streetLogistic'),
  field('Número', 'numberLogistic'),
  field('Bairro', 'districtLogistic'),
  field('Cidade', 'cityLogistic'),
  field('Estado', 'stateLogistic'),
  field('Complemento', 'complementLogistic'),
  field('Reembolso', 'refund'),
  field('Valor Pago Transporte', 'amountPaidTransportation'),
  field('Data de Confirmação', 'confirmationDate'),
  field('Confirmado por', 'confirmedBy'),
  field('Nome Responsável Confirmação', 'nameResponsibleConfirmation'),
  field('E-mail Responsável Confirmação', 'emailResponsibleConfirmation'),
  field('Telefone Responsável Confirmação', 'phoneResponsibleConfirmation'),
  field('Empresa Transporte', 'transportCompany'),
  field('Veículos e Motoristas', 'driverList'),
  field('Horário de Embarque', 'boardingHour'),
  field('Previsão de Chegada', 'arrivalHour'),
  field('Valor Turma', 'trainingValue'),
  field('Valor Transporte', 'transportValue'),
  field('Valor Turma + Valor Transporte', 'trainingAndTransportValue'),
  field('Data de Previsão de Faturamento', 'billingDeadlineDate'),
  field('Razão de não Faturamento', 'reasonNoBilling'),
  field('NF Transporte', 'nfTransportation'),
  field('NF Treinamento', 'nfTraining'),
  field('Número Nota Fiscal', 'invoiceNumber'),
  field('Data de Emissão da Nota Fiscal', 'invoiceEmissionDate'),
  field('Emissor Nota Fiscal', 'invoiceIssuer'),
  field('Valor Nota Fiscal Total', 'totalInvoiceValue'),
  field('Valor Nota Fiscal Parcial', 'partialInvoiceValue'),
  field('Diferença Alunos Confirmados/Treinados', 'qtyStudentsDiff'),
  field('Observação Omie', 'omieNotes'),
  field('Não Possui Certificado', 'notHaveCertificate'),
];

export function filterOsDealFields(fields, searchText) {
  const term = searchText.trim().toLowerCase();
  if (!term) return fields;

  return fields.filter((item) => item.label.toLowerCase().includes(term));
}
